import React, { useEffect, useState } from "react";
import { Form, Skeleton, message, Row, Col } from "antd";
import { SaveButton, InputText, CancelButton, ModalComponent, trans, SelectWithSearch, SelectResourceList } from "@comps/components"
import { makeRequest, makeRequestStateless, getErrorProps } from "@utils/helpers";
import { getCitiesByStateReq, getStatesByCountryReq, updateAddressReq } from "../requests";
import { Commons, Const } from "../../constants";
import { createSelectList } from '@comps/commonFunctions';
import { getAllcountriesReq } from "../../commonRequests";
import { makeFieldLabel } from "@utils/fieldTooltips";
import { employeeTooltips } from "../../common/employeeTooltips";

const langKey = Const["address"].lngKey

const fieldLabel = makeFieldLabel(employeeTooltips.address, { namespace: "address", label: (key) => trans(`${langKey}.${key}`) });

const formName = "updateAddress";

const UpdateAddress = (props) => {

  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [saving, setsaving] = useState(false);
  const [loading, setLoading] = useState(true)
  const [form] = Form.useForm()
  useEffect(() => {
    getAndSetRecord();

    makeRequestStateless(getAllcountriesReq, false, onGetCountries, false);
    // eslint-disable-next-line
  }, []);
  const getAndSetRecord = () => {
    if (!props.record) {
      return;
    }
    onChangeCountry(props.record.country_id);
    onChangeState(props.record.state_id);
    form.setFieldsValue(props.record)
  }

  const onGetCountries = (response) => {
    setCountries(createSelectList(response.countries))
    setLoading(false)
  }
  const onSubmit = (data) => {
    setsaving(true)
    const payload = { employee_address: data, filters: props.filters }
    payload.id = props.record.id;
    makeRequest(setLoader, updateAddressReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {
    message.success("Address Updated successfully");
    setsaving(false)
    props.onCompleted(data.employee_addresses.data);

  }

  const onError = (err, res) => {
    message.error(res.response.data.message);
    //setErrors(errorList);
  }
  //-----------on changes------------

  const onChangeCountry = (id) => {
    makeRequestStateless(getStatesByCountryReq, id, onGetStates, false)
  }

  const onGetStates = (data, response) => {
    setStates(createSelectList(data.all_states))
  }

  const onChangeState = (id) => {
    makeRequestStateless(getCitiesByStateReq, id, onGetCities, false)
  }

  const onGetCities = (data, response) => {
    setCities(createSelectList(data.cities))

  }
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------

  const footer = [
    <SaveButton loading={ saving } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 20 } width={ 1000 } maskClosable={ false }
      mainTitle={ trans(Commons[props.disabled ? 'view' : 'update']) } subTitle={ trans(`${langKey}.address`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Skeleton loading={ loading }>
        <Form { ...formLayout } form={ form } name={ formName } onFinish={ onSubmit } scrollToFirstError>
          <Row gutter={ 30 }>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="employee_id" label={ fieldLabel("employee_id", trans(`${langKey}.select.employee`)) } rules={ rules.employee_id } className="da-mb-16"
                { ...getErrorProps(errors['employee_id']) }
              >
                <SelectResourceList type='employee' disabled={ props.filters !== undefined } value={ props.record.employee_id } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="address_type" label={ fieldLabel("address_type", trans(`${langKey}.select.addresstype`)) } rules={ rules.address_type } className="da-mb-16"
                { ...getErrorProps(errors['address_type']) }
              >
                <SelectWithSearch
                  placeholder={ trans(`${langKey}.select.addresstype`) }
                  options={ [
                    {
                      value: 'Permanent',
                      label: 'Permanent',
                    },
                    {
                      value: 'Present',
                      label: 'Present',
                    },
                  ] }
                />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="complete_address" rules={ rules.complete_address } label={ fieldLabel("complete_address", trans(`${langKey}.completeAddress`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['name']) } size="small"
              >
                <InputText placeholder={ trans(`${langKey}.completeAddress`) } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="country_id" label={ fieldLabel("country_id", trans(`${langKey}.select.country`)) } rules={ rules.country_id } className="da-mb-16"
                { ...getErrorProps(errors['country_id']) }
              >
                <SelectWithSearch
                  onChange={ onChangeCountry }
                  placeholder={ trans(`${langKey}.select.country`) }
                  options={ countries }
                />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="state_id" label={ fieldLabel("state_id", trans(`${langKey}.select.state`)) } rules={ rules.state_id } className="da-mb-16"
                { ...getErrorProps(errors['state_id']) }
                disabled={ true }
              >
                <SelectWithSearch
                  onChange={ onChangeState }
                  placeholder={ trans(`${langKey}.select.state`) }
                  options={ states }
                />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="city_id" label={ fieldLabel("city_id", trans(`${langKey}.select.city`)) } rules={ rules.city_id } className="da-mb-16"
                { ...getErrorProps(errors['city_id']) }
                disabled={ true }
              >
                <SelectWithSearch
                  placeholder={ trans(`${langKey}.select.city`) }
                  options={ cities }
                />
              </Form.Item>
            </Col>
          </Row>

        </Form>
      </Skeleton>

    </ModalComponent>
  )
}

export default UpdateAddress

const rules = {
  complete_address: [
    { required: true, message: trans(`${langKey}.address.req`) },
  ],
  employee_id: [
    { required: true, message: trans(`${langKey}.employee.req`) },
  ],
  address_type: [
    { required: true, message: trans(`${langKey}.addresstype.req`) },
  ],

};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}